import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TablePagination, 
  TableRow, 
  Paper, 
  Checkbox, 
  Collapse, 
  Box, 
  TableHead, 
  IconButton 
} from '@material-ui/core';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import { useReactToPrint } from 'react-to-print';
import { useDispatch, useSelector } from "react-redux";
import { generatePdf, exportExcel, candidatosBajaLimpiar, realizarBaja } from "../../../actions/candidatosBaja";
import { fetchCausaBajas } from "../../../actions/cbos/causaBajas";
import { fetchCategorias } from "../../../actions/cbos/categorias";
import { TableToolbar } from "./TableToolbar";
import { TableHeadBajas } from "./TableHeadBajas";
import { AlertFinalizadoStepper } from "../../stepper/AlertFinalizadoStepper";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  rootTableRow: {
    '& > *': {
      borderBottom: 'unset',
    },
  }
}));

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export function CandidatosBajasConMotivo() {
  
  const classes = useStyles();
  const dispatch = useDispatch();

  const { items: rows } = useSelector((state) => state.candidatosBaja);
  const { items: categorias } = useSelector((state) => state.categorias);
  const { items: causas } = useSelector((state) => state.causaBajas);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("calories");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense/* , setDense */] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [idMotivo, setIdMotivo] = useState(null);
  const [idTipo, setIdTipo] = useState(null);
  const [periodo, setPeriodo] = useState(null);
  const [open, setOpen] = useState(false);
  const [openQuestion, setOpenQuestion] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [fechaVigencia, setFechaVigencia] = useState(new Date());

  useEffect(() => {
    dispatch( fetchCategorias() );
    dispatch( fetchCausaBajas() );
    dispatch( candidatosBajaLimpiar() );
  }, [dispatch]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.idAfiliado);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, idAfiliado) => {
    const selectedIndex = selected.indexOf(idAfiliado);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, idAfiliado);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const componentRef = useRef();
  
  const setFullTable = () => {
    setPage(0);
    setRowsPerPage(rows.length);
  }

  const setDefaultPagination = () => {
    setPage(0);
    setRowsPerPage(8);
  }

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onBeforePrint: setFullTable,
    onAfterPrint: setDefaultPagination
  });

  const handleGeneratePdf = (idTipo, periodo) => {
    // TODO add filters
    if(idTipo!=null) dispatch( generatePdf(idTipo, periodo) );
  }

  const handleExportExcel = (idTipo, periodo) => {
    // TODO add filters
    if(idTipo!=null) dispatch( exportExcel(idTipo, periodo) );
  }

  const handleCormfirmQuestion = () => {
    setOpenQuestion(false);
    setOpenConfirmation(true);
  }

  const handleConfirmarBaja = () => {
    dispatch( realizarBaja(fechaVigencia, selected) );
    setOpenConfirmation(false);
    setSelected([]);
  }  

  return (      
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <TableToolbar 
          numSelected={selected.length} 
          {...{
            causas,
            categorias,
            idMotivo,
            setIdMotivo,
            idTipo,
            setIdTipo,
            handlePrint,
            handleGeneratePdf,
            handleExportExcel,
            periodo,
            setPeriodo
          }}
          handleSubmit={() => setOpenQuestion(true)}
        />
        <TableContainer>
          <Table
            ref={componentRef}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
            aria-label="enhanced table"
          >
            <TableHeadBajas
              numSelected={selected.length}
              {...{ classes, order, orderBy }}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.idAfiliado);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  const periodos = row.periodosImpagos
                  const splitPeriodo = periodos !== null ? periodos.split(',') : ['']

                  const periodToRender = () => {
                    if(periodos < 7 || periodos === null){
                      return (
                        <TableRow key={index}>
                          <TableCell>{periodos}</TableCell>
                        </TableRow>    
                      )
                    }else{
                      return (
                        splitPeriodo.map((periodo)=>(
                          <TableRow key={index}>
                            <TableCell>{periodo}</TableCell>
                          </TableRow>                                  
                        ))
                      )
                    }
                  }

                  return (
                    <>
                      <TableRow
                        hover
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.idAfiliado}
                        selected={isItemSelected}
                        className={classes.rootTableRow}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={isItemSelected}
                            inputProps={{ "aria-labelledby": labelId }}
                            onClick={(event) => handleClick(event, row.idAfiliado)}
                          />
                        </TableCell>
                        <TableCell padding="none">{row.apellido_nombre}</TableCell>
                        <TableCell>
                          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                          </IconButton>
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {new Date(row.fecha_vigencia).toLocaleString(
                            "es",
                            optionsfecha
                          )}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.fecha_fin_cobertura === null ? 'No especifica' : new Date(row.fecha_fin_cobertura).toLocaleString(
                            "es",
                            optionsfecha
                          )}
                        </TableCell>
                        <TableCell>{row.cuil}</TableCell>
                        <TableCell>{row.denominacion}</TableCell>
                        <TableCell>{row.cuit}</TableCell>
                        <TableCell>{row.descripcion_afiliacion === null ? 'No especifica' : row.descripcion_afiliacion}</TableCell>  
                        <TableCell>
                          <Checkbox
                              checked={row.judicializado}
                              disabled={true}
                          />
                        </TableCell>  
                        <TableCell>
                          <Checkbox
                              checked={row.moratoria}
                              disabled={true}
                          />
                        </TableCell>    
                        <TableCell>
                          <Checkbox
                              checked={row.incapacitado}
                              disabled={true}
                          />
                        </TableCell>          
                      </TableRow>
                      <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
                          <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box margin={1}>
                              <Table size="small" aria-label="purchases">
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Períodos Impagos</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>{periodToRender()}</TableBody>
                              </Table>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </>
                  )
                })}
              {rows.length === 0 && (
                <TableRow style={{ height: 50 }}>
                  <TableCell colSpan={10} style={{textAlign: '-webkit-center'}}>Sin Registros</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          {...{ rowsPerPage, page }}
          labelRowsPerPage='Registros por página'
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
        {openQuestion && 
          <AlertFinalizadoStepper
            open={openQuestion}
            pregunta={"Baja de Afiliados"}
            dialogText={`Indique la fecha a dar de baja los afiliados?`}
            buttonCancel={"Cancelar"}
            buttonSubmit={"Continuar"}
            showDateDialog={true}
            fechaVigencia={fechaVigencia}
            setFechaVigencia={setFechaVigencia}
            handleClose={() => setOpenQuestion(false)}
            handleSend={handleCormfirmQuestion}
          />
        }
        {openConfirmation && (
          <AlertFinalizadoStepper
            open={openConfirmation}
            pregunta={"Confirmación Baja de Afiliados"}
            dialogText={`Quiere proceder con la baja de ${selected.length} afiliados`}
            buttonCancel={"Cancelar"}
            buttonSubmit={"Confirmar"}
            handleClose={() => setOpenConfirmation(false)}
            handleSend={handleConfirmarBaja}
          />
        )}  
      </Paper>
    </div>
  );
}
